import { render, staticRenderFns } from "./metrics_score_distribution.vue?vue&type=template&id=b5e39f56&scoped=true&"
import script from "./metrics_score_distribution.vue?vue&type=script&lang=js&"
export * from "./metrics_score_distribution.vue?vue&type=script&lang=js&"
import style0 from "./metrics_score_distribution.vue?vue&type=style&index=0&id=b5e39f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e39f56",
  null
  
)

export default component.exports